<template>
	<div>
		<p> * Процентная ставка при подтверждении занятости и дохода <span @click="showModalPfr" class="link">выпиской из СФР</span>. </p>
		<p class="_mt-12"> При отсутствии возможности подтверждения занятости и дохода выпиской из СФР выберите опцию «Без подтверждения занятости и дохода» в блоке Дополнительные опции. </p>
	</div>
</template>

<script>
export default {
	name: "MortgageCalculatorPfr",
	props: {
		hidePfr: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		showModalPfr() {
			this.$emit('showPfrModal');
		}
	}
}
</script>
